<h1 mat-dialog-title>Print documents</h1>
<div mat-dialog-content  class="content-dialog">
    <app-document-list [documentList]="documentList" (documentSelected)="onSelect($event)"></app-document-list>
</div>
<div mat-dialog-actions [align]="'end'">
  <button mat-stroked-button [mat-dialog-close]="">Close</button>
  <button mat-stroked-button (click)="onPrint()" cdkFocusInitial>Print</button>
</div>
